import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  title = 'Saiyarti';

  navbarOpen = false;
  authentication = true;

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }
}
